import { de } from './de';
import { en } from './en';
import { ru } from './ru';
import { ua } from './ua';
import { pl } from './pl';
import { cz } from './cz';
import { md } from './md';
import { bg } from './bg';
import { kz } from './kz';

export type Lang = 'de' | 'en' | 'ru' | 'ua' | 'pl' | 'cz' | 'md' | 'bg' | 'kz';
export type Content = typeof de;

export const content: Record<Lang, Content> = { de, en, ru, ua, pl, cz, md, bg, kz };
